module.exports = __webpack_public_path__ + "static/img/Adinda Lestari-full.01c1f02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/full/Adinda Lestari-full.png
// module id = D5B2
// module chunks = 1